import React, { Fragment, ReactNode } from 'react'
import { useStepperContext } from '../context/StepperContext'

interface StepProps {
  position: number
  children: ReactNode
}

export const Step = ({ children, position }: StepProps) => {
  const { currentStep } = useStepperContext()

  if (currentStep !== position) {
    return null
  }

  return <Fragment>{children}</Fragment>
}
